export default __webpack_public_path__ + "static/media/pictogramBeaconDonations128.ee4b862e.svg";